import { getLayerIdentifier, isCopperLayer, PrimitiveRole, PrimitiveType, } from "@buildwithflux/models";
import { mat3 } from "../../../common";
import { TraceCorners } from "../../libs/traceCorners";
// TODO: This implementation is currently missing solder mask (and expansion)
// This means that it will work fine for copper DRC but not for rendering or other stuff
export function createPrimitivesForRouteSegment(node, allNodes, tracingGraph, stackup) {
    const transform = node.bakedRules.transformRelativeToShapesLayer ?? mat3.makeIdentity();
    const transformInverse = mat3.invert(transform);
    const layer = stackup.find((layer) => isCopperLayer(layer) && getLayerIdentifier(layer) === node.bakedRules.layer);
    if (!layer) {
        return [];
    }
    const linePrimitive = {
        role: PrimitiveRole.copper,
        type: PrimitiveType.Line,
        layerId: layer.uid,
        transform,
        transformInverse,
        startX: node.bakedRules.startPosition.x,
        startY: node.bakedRules.startPosition.y,
        endX: node.bakedRules.endPosition.x,
        endY: node.bakedRules.endPosition.y,
        thickness: node.bakedRules.size.x,
        cacheKey: "",
    };
    linePrimitive.cacheKey = JSON.stringify(linePrimitive);
    const primitives = [linePrimitive]; // Inserted rectangle at RouteSegmentPrimitiveIndexRectangle
    const start = TraceCorners.computeForVertex("start", node, allNodes, tracingGraph.getGraph());
    if (start) {
        linePrimitive.startX = start.vertex.x;
        linePrimitive.startY = start.vertex.y;
        const arc = {
            ...start.arc,
            type: PrimitiveType.LineArc,
            role: PrimitiveRole.copper,
            layerId: layer.uid,
            transform,
            transformInverse,
            thickness: node.bakedRules.size.x,
            traceVertex: "start",
            cacheKey: "",
        };
        arc.cacheKey = JSON.stringify(arc);
        primitives.push(arc);
    }
    const end = TraceCorners.computeForVertex("end", node, allNodes, tracingGraph.getGraph());
    if (end) {
        linePrimitive.endX = end.vertex.x;
        linePrimitive.endY = end.vertex.y;
        const arc = {
            ...end.arc,
            type: PrimitiveType.LineArc,
            role: PrimitiveRole.copper,
            layerId: layer.uid,
            transform,
            transformInverse,
            thickness: node.bakedRules.size.x,
            traceVertex: "end",
            cacheKey: "",
        };
        arc.cacheKey = JSON.stringify(arc);
        primitives.push(arc);
    }
    return primitives;
}
//# sourceMappingURL=createPrimitivesForRouteSegment.js.map